import { render, staticRenderFns } from "./BirthdayPopup.vue?vue&type=template&id=56c2dd5d"
import script from "./BirthdayPopup.vue?vue&type=script&lang=js"
export * from "./BirthdayPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports